import { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../services/firebase";
import { doc, onSnapshot } from "firebase/firestore";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { Unauthorized } from "../common/unauthorized";

export const Maintenance = () => {
  const [surveyType, setSurveyType] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [role, setRole] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    if (pathnames.length > 1) {
      setSurveyType(pathnames[1].toUpperCase());
    } else {
      setSurveyType("");
    }
  }, [location]);

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");

    const unsubscribe = onSnapshot(doc(db, "users", user?.uid), (doc) => {
      setRole(doc.data().role);
      //setRole("Admin");
      //console.log(role);
    });

    return () => unsubscribe();
  }, [user, loading]);

  return (
    <div>
      {(!role || role !== "Admin") && <Unauthorized></Unauthorized>}
      {!surveyType && role === "Admin" && (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          spacing={1}
        >
          <Box display="flex" justifyContent="space-between" p={2}>
            <Typography variant="h5">Maintenance</Typography>

            <Box display="flex"></Box>
          </Box>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/users')}
          >
            Manage Users
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/products')}
          >
            Manage Products
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/locations')}
          >
            Manage Locations
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/tanks')}
          >
            Manage Tanks
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/trucks')}
          >
            Manage Trucks
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/inventories')}
          >
            Inventory Entries
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/maintenance/purchases')}
          >
            Transaction Entries
          </Button>
        </Stack>
      )}
      <Outlet />
    </div>
  );
};
